module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<nav class="module-menu"><ul><li><a class="snippet" href="#" data-click="nav-recipients">'+
((__t=( i18n.tc( "ControlNotifications", "Edit recipients" ) ))==null?'':__t)+
'</a></li><li><a class="snippet" href="#" data-click="nav-all">'+
((__t=( i18n.tc( "ControlNotifications", "All notifications" ) ))==null?'':__t)+
'</a></li></ul></nav>';
}
return __p;
};
